// extracted by mini-css-extract-plugin
export default {"dummySliderTrackEnd":"hover-overlay-module__dummySliderTrackEnd--nTcn6","hoverOverlay":"hover-overlay-module__hoverOverlay--CKeAu"};